"use client";

import { eventDialogOpenAtom, eventEditModeAtom, selectedEventAtom } from "@/atoms/calendarAtoms";
import { Event, Group, Workspace } from "@/db/schema";
import { useAtom } from "jotai";
import { CalendarEventBlock } from "./CalendarEventBlock";

function row(event: Event, group: Group) {
  const startBlock =
    1 +
    (new Date(event.startDate).getHours() * 2 + new Date(event.startDate).getMinutes() / 30) -
    group.openHour * 2;
  const endBlock =
    1 +
    (new Date(event.endDate).getHours() * 2 + new Date(event.endDate).getMinutes() / 30) -
    group.openHour * 2;

  const span = endBlock - startBlock;

  return `${Math.round(startBlock)} / span ${Math.round(span)}`;
}

export default function CalendarEvents({
  events,
  workspace,
  group,
}: {
  events: Event[];
  workspace: Workspace;
  group: Group;
}) {
  const [, setSelectedEvent] = useAtom(selectedEventAtom);
  const [, setEventDialogOpen] = useAtom(eventDialogOpenAtom);
  const [, setEditMode] = useAtom(eventEditModeAtom);

  const handleEventClick = (event: Event) => {
    setSelectedEvent(event);
    setEditMode(false);
    setEventDialogOpen(true);
  };

  return (
    <>
      {events.map((event) => (
        <div
          key={event.id}
          className="col-span-1 col-start-2 md:col-start-1 p-1"
          style={{
            gridRow: row(event, group),
          }}
        >
          <CalendarEventBlock event={event} group={group} onClick={() => handleEventClick(event)} />
        </div>
      ))}
    </>
  );
}
